import translations from './Languages.js'

// Requirements for every newly set password (#602): changing it, Wachtwoord vergeten and the welcome mail. Shared by
// the forms and the server, so the list on screen and the check on the server are the same. Existing passwords stay
// valid, logging in does not check them.

export const PASSWORD_MIN_LENGTH = 12

export type PasswordRequirementId = 'length' | 'letterAndDigit' | 'different'

type Requirement = {
    id: PasswordRequirementId
    // Key in utils/Languages.ts, the text follows "Je nieuwe wachtwoord moet:"
    text: 'passwordRequirementLength' | 'passwordRequirementLetterAndDigit' | 'passwordRequirementDifferent'
    met: (password: string, currentPassword?: string) => boolean
}

export const passwordRequirements: Requirement[] = [
    {id: 'length', text: 'passwordRequirementLength', met: (password) => password.length >= PASSWORD_MIN_LENGTH},
    {id: 'letterAndDigit', text: 'passwordRequirementLetterAndDigit', met: (password) => /\p{L}/u.test(password) && /\d/.test(password)},
    // Only where the current password is known: changing it from the account menu
    {id: 'different', text: 'passwordRequirementDifferent', met: (password, currentPassword) => password !== currentPassword}
]

/** The requirements that apply: "different" only when the current password is asked for. */
export function applicableRequirements(withCurrentPassword: boolean): Requirement[] {
    return passwordRequirements.filter((requirement) => withCurrentPassword || requirement.id !== 'different')
}

/** The first requirement the password does not meet, null when it meets all. */
export function unmetRequirement(password: unknown, currentPassword?: string): Requirement | null {
    const value = typeof password === 'string' ? password : ''
    return applicableRequirements(typeof currentPassword === 'string').find((requirement) => !requirement.met(value, currentPassword)) || null
}

/** The server's message for a password that does not meet a requirement. */
export function unmetRequirementMessage(requirement: Requirement): string {
    return `${translations.passwordRequirementsIntro.NL} ${translations[requirement.text].NL.charAt(0).toLowerCase()}${translations[requirement.text].NL.slice(1)}.`
}
